import React from "react";
import { Fab, Box, Tooltip } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { colorPrimary } from "../../Styles/Colors";

const SmallFAB = ({
  icon = <EditIcon />,
  variant = "surface", // surface, primary, secondary, tertiary
  size = "small",
  tooltip,
  disabled = false,
  onClick,
  sx = {},
  ...props
}) => {
  // Get styles based on variant (matching Figma design)
  const getVariantStyles = () => {
    switch (variant) {
      case "surface":
        return {
          background: "#F3E4EA",
          color: colorPrimary,
          boxShadow:
            "0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)",
          "&:hover": {
            backgroundColor: "#F3E4EA",
          },
        };
      case "primary":
        return {
          borderRadius: "12px",
          background: "#8A3975",
          color: "#ffffff",
          boxShadow:
            "0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)",
          "&:hover": {
            backgroundColor: "#8A3975",
          },
  };
case "secondary":
  return {
    borderRadius: "12px",
    background: "var(--SMA-sys-light-secondary-container, #FFD2EC)",
    boxShadow:
      "0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)",
    "&:hover": {
      backgroundColor: "#d1a7d8",
    },
  };
case "tertiary":
  return {
    borderRadius: "12px",
    background: "var(--SMA-sys-light-tertiary-container, #FF9C33)",
    boxShadow:
      "0 4px 8px 3px rgba(0, 0, 0, 0.15), 0 1px 3px 0 rgba(0, 0, 0, 0.30)",
    "&:hover": {
      backgroundColor: "#f57c00",
    },
  };
default:
        return {};
    }
  };

  const fabComponent = (
    <Fab
      size={size}
      disabled={disabled}
      onClick={onClick}
      sx={{
        ...getVariantStyles(),
        width: "40px",
        height: "40px",
        minHeight: "40px",
        borderRadius: "12px",

        "&:hover": {
          boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
          ...getVariantStyles()["&:hover"],
        },
        ...sx,
      }}
      {...props}
    >
      {icon}
    </Fab>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} arrow>
        {fabComponent}
      </Tooltip>
    );
  }

  return fabComponent;
};

export default SmallFAB;
